var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7273,
    cy: 47.7273,
    r: 47.7273,
    fill: "#B2DEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0235 71.1323C55.0235 66.3161 53.233 63.8651 48.5672 61.8966C43.9169 59.9367 42.4317 58.2855 42.4317 54.7474C42.4317 52.6266 43.8511 53.3171 44.4732 49.4272C44.7361 47.8147 45.989 49.4015 46.23 45.7197C46.23 44.2529 45.5444 43.8884 45.5444 43.8884C45.5444 43.8884 45.8927 41.7162 46.0285 40.0436C46.1687 38.2916 45.1567 34.554 40.9882 33.4068C36.0915 32.0592 33.35 34.4919 33.35 34.4919C31.1267 36.113 30.5265 38.6798 30.6338 40.0457C30.7762 41.7183 31.1223 43.8905 31.1223 43.8905C31.1223 43.8905 30.4345 44.2551 30.4345 45.7218C30.6754 49.4058 31.9328 47.8168 32.1934 49.4294C32.8155 53.3192 34.2371 52.6287 34.2371 54.7495C34.2371 58.2877 33.7728 59.4885 29.1202 61.4484C24.4523 63.4148 23 66.567 23.0241 71.1323C23.0307 72.4983 23 73 23 73H55.0476C55.0476 73 55.0235 72.4983 55.0235 71.1323Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 19.6802C54.6131 19.6802 52.3239 20.6284 50.636 22.3162C48.9482 24.004 48 26.2932 48 28.6802C48 31.0671 48.9482 33.3563 50.636 35.0441C52.3239 36.732 54.6131 37.6802 57 37.6802C59.3869 37.6802 61.6761 36.732 63.364 35.0441C65.0518 33.3563 66 31.0671 66 28.6802C66 26.2932 65.0518 24.004 63.364 22.3162C61.6761 20.6284 59.3869 19.6802 57 19.6802ZM61.0909 30.3165H58.6364V32.7711C58.6364 33.2051 58.464 33.6213 58.1571 33.9282C57.8502 34.235 57.434 34.4074 57 34.4074C56.566 34.4074 56.1498 34.235 55.8429 33.9282C55.536 33.6213 55.3636 33.2051 55.3636 32.7711V30.3165H52.9091C52.4751 30.3165 52.0589 30.1441 51.752 29.8373C51.4451 29.5304 51.2727 29.1142 51.2727 28.6802C51.2727 28.2462 51.4451 27.83 51.752 27.5231C52.0589 27.2162 52.4751 27.0438 52.9091 27.0438H55.3636V24.5893C55.3636 24.1553 55.536 23.7391 55.8429 23.4322C56.1498 23.1253 56.566 22.9529 57 22.9529C57.434 22.9529 57.8502 23.1253 58.1571 23.4322C58.464 23.7391 58.6364 24.1553 58.6364 24.5893V27.0438H61.0909C61.5249 27.0438 61.9411 27.2162 62.248 27.5231C62.5549 27.83 62.7273 28.2462 62.7273 28.6802C62.7273 29.1142 62.5549 29.5304 62.248 29.8373C61.9411 30.1441 61.5249 30.3165 61.0909 30.3165Z",
    fill: "#408298"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6802 60.3601H54.6802Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6802 60.3601H54.6802",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4399 55H56.4399Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4399 55H56.4399",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6802 49.8H54.6802Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6802 49.8H54.6802",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupMonth);
export default __webpack_public_path__ + "static/media/signupMonth.ff26cf9ee8a11354255f251aa90a5660.svg";
export { ForwardRef as ReactComponent };